<div class="description bedrock">
  <div class="model-response">
    <markdown [data]="reconstitutedText" [disableSanitizer]="true"> </markdown>
  </div>
</div>
<smart-fix-video-preview
  *ngIf="showPreview"
  [messageText]="reconstitutedText"
></smart-fix-video-preview>
